module.exports = __webpack_public_path__ + "1d80a357b7221973d2646c218249310f.pdf";